import { z } from 'zod';
import { idSchema } from './common.js';
/**
 * Certificado digital A1 (e-CNPJ) — a chave para falar com a SEFAZ.
 *
 * O arquivo e a senha NUNCA voltam pela API: o contrato de saída tem só o que
 * a tela precisa mostrar (titular, CNPJ, validade e quando foi a última busca).
 */
export const digitalCertificateSchema = z.object({
    id: idSchema,
    companyId: idSchema,
    fileName: z.string(),
    subjectName: z.string(),
    document: z.string(),
    issuedAt: z.string(),
    expiresAt: z.string(),
    isActive: z.boolean(),
    isExpired: z.boolean(),
    /// Negativo quando já venceu — a tela avisa antes de virar problema.
    daysToExpire: z.number().int(),
    lastNsu: z.string(),
    lastSyncAt: z.string().nullable(),
    createdAt: z.string(),
});
export const digitalCertificateInputSchema = z.object({
    fileName: z.string().trim().min(1, 'Informe o nome do arquivo').max(180),
    /// Conteúdo do .pfx em base64 (limite ~1,3 MB de base64 ≈ 1 MB de arquivo).
    fileBase64: z.string().min(100, 'Envie o arquivo do certificado').max(1_400_000),
    password: z.string().min(1, 'Informe a senha do certificado').max(200),
});
/** Busca das notas na SEFAZ. A UF define o autor da consulta. */
export const sefazSyncInputSchema = z.object({
    uf: z.string().trim().length(2).toUpperCase().default('AC'),
});
export const sefazSyncResultSchema = z.object({
    imported: z.number().int(),
    skipped: z.number().int(),
    lastNsu: z.string(),
    hasMore: z.boolean(),
    message: z.string(),
});
//# sourceMappingURL=fiscal.js.map